import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { batch } from 'react-redux';
import { AppThunk } from "./store";
//import axios, { AxiosError } from "axios";
import { setAllStates, startLoading, stopLoading } from "./Loading_Slice";
import { buildQueryString } from 'utils/solr';
import { fetchWithTimeout } from 'utils/fetchWithTimeout';
import CONSTANTS from "../constants";
import logger from "../logger"
import { getSummaryShort, setSummary } from 'services/Summary_Slice';
import { toastListProp, toastType, createToastProperties } from '../components/toast/Toast';
import { addToQueue} from "../services/Toasts_Slice";
//
const urldecode = require('urldecode');


// facetMap: map with one facet type 'genre_s' with  names: {"facetdMap":{"genre_s":["cryosat-2","TERRASARX"]}}
// facetSelected: array of facetValue@facetName
// currentFacetMap: as per facetMap, but for new facet UI
//
export type FacetsState = {
    facetMap: {[name: string]: Array<string>},
    facetSelected: Array<string>,
    currentFacetMap: {[name: string]: Array<string>},
}

//
export type FacetsMap = {[name: string]: Array<string>};

// dictionnary of facets
export type FacetsMapPayload = {
    facetMap: {[name: string]: Array<string>},
}

// array of selected facet
export type FacetsSelected =  Array<string>;


// ad done facet
export type OneFacetsSelectedPayload = string


//
let initialState: FacetsState = {
    facetMap: {
        // loading: [CONSTANTS.STATE_NOT_SET]
    },
    facetSelected: [],
    currentFacetMap: {
        // loading: [CONSTANTS.STATE_NOT_SET]
    }
};


const facetSlice = createSlice({
    name: 'Facets',
    initialState: initialState,
    reducers: {
        setFacetsMap(state, action: PayloadAction<FacetsMapPayload>) {
            state.facetMap = action.payload.facetMap;
        },
        setCurrentFacetsMap(state, action: PayloadAction<FacetsMapPayload>) {
            state.currentFacetMap = action.payload.facetMap;
        },
        setFacetSelected(state, action: PayloadAction<FacetsSelected>) {
            state.facetSelected=action.payload;
        },
        addOneFacetSelected(state, action: PayloadAction<OneFacetsSelectedPayload>) {
            if (state.facetSelected.includes(action.payload)){
                //logger.debug("addOneFacetSelected: already in facetSelected:"+action.payload);
            }else{
                state.facetSelected.push(action.payload);
            }
        },
        removeOneFacetSelected(state, action: PayloadAction<OneFacetsSelectedPayload>) {
            //logger.debug("removeOneFacetSelected: '"+action.payload+"'");
            if (state.facetSelected.includes(action.payload)){
                //logger.debug("removeOneFacetSelected: new state"+ JSON.stringify(state.facetSelected.filter(item => item !== action.payload)));
                state.facetSelected = state.facetSelected.filter(item => item !== action.payload);
            }else{
                //logger.debug("removeOneFacetSelected: not present in facetSelected:"+action.payload);
            }
        },
        removeGroupFacetSelected(state, action: PayloadAction<string>) {
            //logger.debug("removeGroupFacetSelected: group name="+action.payload);
            var newArray: string[] = [];
            for( var val in state.facetSelected){
                if(state.facetSelected[val].split("@")[1]!==action.payload){
                    newArray.push(state.facetSelected[val]);
                }
            }
            //logger.debug("removeGroupFacetSelected: newArray="+newArray);
            state.facetSelected=newArray;
        }
    }
});


//
// get all the available facet names + values. i.e. when no criteria used
// 
//
export const getAvailableFacets = (facetConstraints: Array<string>): AppThunk => async dispatch => {
    // Background operation - don't block UI with loading spinner
    // dispatch(startLoading());

    fetchWithTimeout(CONSTANTS.ENDPOINT.REST_API + CONSTANTS.REST_GET_FACETS)
        .then(response => {
            ////logger.debug("response 0: " + Response);
            if(response.ok){
                //logger.debug("getAvailableFacets response 0: ok");
                return response.json();
            }else{
                //logger.debug("getAvailableFacets response 0: not ok");
                throw new Error('Network response was not ok:' + response.status);
            }
        })
        .then(data => {
            //logger.info("## getAvailableFacets data.payload: " + JSON.stringify(data));

            if (CONSTANTS.BACKEND_REPLY_IS_ERROR in data){
                //logger.error("##################### getAvailableFacets error:" + data[CONSTANTS.BACKEND_REPLY_IS_ERROR]);
                const toastProperties: toastListProp = createToastProperties(toastType.error, CONSTANTS.REST_GET_FACETS_ALIAS, data[CONSTANTS.BACKEND_REPLY_IS_ERROR]);
                dispatch(addToQueue(toastProperties));
            }else{
                batch(() => {
                    dispatch(setFacetsMap(data));
                    dispatch(setCurrentFacetsMap(data));
                });
            }
            // Background operation - don't affect loading counter
            // dispatch(stopLoading({success: true}));
        })
        .catch((error) => {
            //logger.error("## getAvailableFacets: error="+error);
            console.error(error.stack);
            // Background operation - don't affect loading counter
            // dispatch(stopLoading({success: false, error: error.message}));
            const toastProperties: toastListProp = createToastProperties(toastType.error, CONSTANTS.REST_GET_FACETS_ALIAS, error.message);
            dispatch(addToQueue(toastProperties));
        })
};


//
// get all the available facet names +  the values in scope
//
// Id of the most recent getCurrentFacets request; replies of older requests are ignored
let currentFacetsRequestId = 0;

export const getCurrentFacets = (facetMap: FacetsMap, facetSelected: FacetsSelected, operator: string, searchConstraints?: string, dateIntervalFrom?: string | null, dateIntervalTo?: string | null): AppThunk => async dispatch => {

    // Background operation - don't block UI with loading spinner
    // dispatch(startLoading());

    // Build query for getCurrentFacets
    const facetsQuery = buildQueryString(
        "*:*",
        searchConstraints || "*",
        dateIntervalFrom ?? undefined,
        dateIntervalTo ?? undefined,
        facetSelected,
        facetMap,
        operator
        );


    // Build query for getSummaryShort
    const summaryQuery = buildQueryString(
        "*:*",
        searchConstraints || "*",
        dateIntervalFrom ?? undefined,
        dateIntervalTo ?? undefined,
        facetSelected,
        facetMap,
        operator
        );

    const requestId = ++currentFacetsRequestId;

    // Execute both API calls in parallel
    Promise.all([
        fetchWithTimeout(CONSTANTS.ENDPOINT.REST_API + CONSTANTS.REST_GET_CURRENT_FACETS + "?" + facetsQuery),
        fetchWithTimeout(CONSTANTS.ENDPOINT.REST_API + CONSTANTS.REST_GET_SUMMARY_SHORT + "?" + summaryQuery)
    ])
    .then(async ([facetsResponse, summaryResponse]) => {
        // Check if both responses are ok
        if(!facetsResponse.ok){
            throw new Error('Current facets API response was not ok: ' + facetsResponse.status);
        }
        if(!summaryResponse.ok){
            throw new Error('Summary API response was not ok: ' + summaryResponse.status);
        }

        // Parse both responses
        const [facetsData, summaryData] = await Promise.all([
            facetsResponse.json(),
            summaryResponse.json()
        ]);

        // a newer request was sent meanwhile: drop this stale reply (it would overwrite newer facets and summary)
        if (requestId !== currentFacetsRequestId) return;

        batch(() => {
            dispatch(setCurrentFacetsMap(facetsData));

            // Handle summary data
            if (CONSTANTS.BACKEND_REPLY_IS_ERROR in summaryData){
                const toastProperties: toastListProp = createToastProperties(toastType.error, CONSTANTS.REST_GET_SUMMARY_SHORT_ALIAS, summaryData[CONSTANTS.BACKEND_REPLY_IS_ERROR]);
                dispatch(addToQueue(toastProperties));
            } else {
                dispatch(setSummary(summaryData));
            }
        });

        // Background operation - don't affect loading counter
        // dispatch(stopLoading({success: true}));
    })
    .catch((error) => {
        if (requestId !== currentFacetsRequestId) return;
        //logger.error("## getCurrentFacets or getSummaryShort: error="+error);
        dispatch(setAllStates({loading:false, ok:false, error: error.message}));

        // Determine which API failed and show appropriate toast
        if(error.message.includes('Current facets')){
            const toastProperties: toastListProp = createToastProperties(toastType.error, CONSTANTS.REST_GET_CURRENT_FACETS_ALIAS, error.message);
            dispatch(addToQueue(toastProperties));
        } else if(error.message.includes('Summary')){
            const toastProperties: toastListProp = createToastProperties(toastType.error, CONSTANTS.REST_GET_SUMMARY_SHORT_ALIAS, error.message);
            dispatch(addToQueue(toastProperties));
        } else {
            const toastProperties: toastListProp = createToastProperties(toastType.error, "API Error", error.message);
            dispatch(addToQueue(toastProperties));
        }
    })
};


export const {setFacetsMap, setCurrentFacetsMap, addOneFacetSelected, removeOneFacetSelected, setFacetSelected, removeGroupFacetSelected} = facetSlice.actions;

export default facetSlice.reducer